module.exports = __webpack_public_path__ + "img/Groupx@3x.da12439a.png";